import { useWindowSize } from "usehooks-ts";
import { BREAKPOINTS } from "../assets/constants";

export function useIsScreenBelowBreakpoint(
  breakpoint: keyof typeof BREAKPOINTS,
) {
  const { width } = useWindowSize();
  return width < BREAKPOINTS[breakpoint];
}
